import React from 'react';

const DotIcon = ({width="30", height="30", color="#3B5998", link="#", fill="fillcolor"}) => (
  <a href={link} target="_blank" rel="noopener" className="dot-position">
   <svg xmlns="http://www.w3.org/2000/svg" width="3" height="3" viewBox="0 0 3 3" fill={fill}>
    <circle cx="74" cy="8" r="1" fill={fill} fill-rule="evenodd" transform="translate(-73 -7)"/>
</svg>
  </a>
);

export { DotIcon };